export class FailedToResolveExistingQuays extends Error {}
